export default __webpack_public_path__ + "static/media/tik-tok.db2efd4e.svg";